import styled from 'styled-components'
import { Button } from 'antd'

export const ExpandedWrapper = styled.div`
  padding: 16px 24px;
  background: #fafafa;
  border-radius: 4px;
  margin: 8px 0;
`

export const ExpandedHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  
  h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #1f1f1f;
  }
`

export const CreateAdButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const AdsTable = styled.div`
  background: white;
  border-radius: 4px;
  overflow: hidden;
  
  .ant-table {
    font-size: 13px;
  }
  
  .ant-table-thead > tr > th {
    background: #f5f5f5;
    font-weight: 500;
    padding: 8px 12px;
  }
  
  .ant-table-tbody > tr > td {
    padding: 8px 12px;
  }
  
  .ant-table-tbody > tr:hover > td {
    background: #fafafa;
  }
  
  .ant-btn-link {
    padding: 2px 4px;
    height: auto;
  }
`

export const AdPreview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
  
  div {
    font-size: 14px;
    line-height: 1.5;
  }
  
  strong {
    font-weight: 600;
    margin-right: 8px;
  }
`

export const PreviewModal = styled.div`
  .ant-modal-content {
    border-radius: 8px;
  }
  
  .ant-modal-header {
    border-bottom: 1px solid #f0f0f0;
  }
  
  .ant-modal-body {
    padding: 20px;
  }
`

export const PreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const PreviewHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  
  .ant-image {
    border-radius: 8px;
    overflow: hidden;
  }
`

export const PreviewBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  .ant-image {
    border-radius: 8px;
    overflow: hidden;
  }
`

export const PreviewFooter = styled.div`
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
`

export const CtaButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-top: 16px;
`

export const CtaButton = styled(Button)`
  min-width: 120px;
  height: 40px;
  font-weight: 500;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &.ant-btn-primary {
    background: #1890ff;
    border-color: #1890ff;
    
    &:hover, &:focus {
      background: #40a9ff;
      border-color: #40a9ff;
    }
  }
  
  &:not(.ant-btn-primary) {
    background: white;
    border-color: #d9d9d9;
    color: #595959;
    
    &:hover, &:focus {
      background: #f5f5f5;
      border-color: #40a9ff;
      color: #1890ff;
    }
  }
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
  
  transition: all 0.2s ease;
`